import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "error", "previousData"];
/**
 * Warning: This file is auto-generated. Do not modify this file manually.
 * Please refer to the README for more information.
 */

import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { getUserSeatAssignmentsForRequestingUserFailureSchema, getUserSeatAssignmentsForRequestingUserResponseSchema } from 'app-users-service-types/AppUsersService/schema';
import * as Utils from 'app-users-service-client/utils';
const PATH = '/app-users/v1/seat-assignments/self';
const GET_METHOD = 'get';
export const GET_FIELD_NAME = Utils.toValidGraphQLName(PATH, GET_METHOD);
export const GET_FETCHER = () => {
  return http.get(PATH, {}).then(response => {
    Utils.validateResponse(getUserSeatAssignmentsForRequestingUserResponseSchema, response);
    return response;
  }).catch(error => {
    Utils.validateError(getUserSeatAssignmentsForRequestingUserFailureSchema, error);
    throw error;
  });
};
export const GET_QUERY = registerQuery({
  fieldName: GET_FIELD_NAME,
  args: [],
  fetcher: GET_FETCHER
});

/**
 * Query hook for GET /app-users/v1/seat-assignments/self.
 * Requires the following scopes: `users-read`
 */
export const useGetQuery = (__variables, options) => {
  const _useQuery = useQuery(GET_QUERY, options),
    {
      data,
      error,
      previousData
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  return Object.assign({
    /** @deprecated Use `response` instead */
    data: data && data[GET_FIELD_NAME],
    /** @deprecated Use `previousResponse` instead */
    previousData: previousData && previousData[GET_FIELD_NAME],
    response: data && data[GET_FIELD_NAME],
    previousResponse: previousData && previousData[GET_FIELD_NAME],
    error: error && Object.assign({}, error, {
      networkError: error.networkError
    })
  }, rest);
};